'use es6';

export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_CONFIG = 'INITIALIZE_CONFIG';
export const ACTIVE_CURRENCY_CODE_UPDATED = 'ACTIVE_CURRENCY_CODE_UPDATED';
export const QUERY_PARAM_TERM_UPDATED = 'QUERY_PARAM_TERM_UPDATED';
export const QUERY_PARAM_TERM_RESET = 'QUERY_PARAM_TERM_RESET';
export const CUSTOMER_CURRENCY_CODE_RECEIVED = 'CUSTOMER_CURRENCY_CODE_RECEIVED';
export const SUBSCRIPTION_TERMS_RECEIVED = 'SUBSCRIPTION_TERMS_RECEIVED';
export const MERCHANDISE_IDS_TREATED_AS_OWNED_RECEIVED = 'MERCHANDISE_IDS_TREATED_AS_OWNED_RECEIVED';
export const PARCELS_RECEIVED = 'PARCELS_RECEIVED';
export const ACTIVE_HUB_UPDATED = 'ACTIVE_HUB_UPDATED';
export const PHONE_NUMBERS_RECEIVED = 'PHONE_NUMBERS_RECEIVED';
export const EXPERIMENT_TREATMENTS_REQUESTED = 'EXPERIMENT_TREATMENTS_REQUESTED';
export const EXPERIMENT_TREATMENTS_RECEIVED = 'EXPERIMENT_TREATMENTS_RECEIVED';
export const PUBLIC_FEATURE_FLAGS_RECEIVED = 'PUBLIC_FEATURE_FLAGS_RECEIVED';